var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { updateDataFromCollection } from './utils';
import { setAllTakes } from './takes';
import { setAllRelTakesFlags } from './takesFlags';
import { setAssetsFromTasks } from './assets';
import { setAllActivities } from './reduxActivities';
import { setAllTakeValidationMedias } from './reduxTakeValidationMedias';
import { setAllTakeRefMedias } from './reduxTakeRefMedias';
import { setAllMedias } from './reduxMedias';
import { setStateKey } from './stateKey';
import { verifyStartEndEarlyLatestDates } from 'app/store/hooks/tasks.js';
const initialState = {
    allTasks: [],
    data: [],
    stats: null,
    loading: true,
    count: 0,
    statsIsLoading: false,
    httpProgress: 0,
};
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
export const fetchAllTasks = createAsyncThunk('reduxTasks/fetchAll', (queries_1, _a) => __awaiter(void 0, [queries_1, _a], void 0, function* (queries, { fulfillWithValue, rejectWithValue, dispatch }) {
    if (!queries.ordering)
        delete queries.ordering;
    try {
        const res = yield api.tasks.fetchAll(Object.assign(Object.assign({}, queries), { statMode: 'datasOnly' }), {}, (progress) => {
            dispatch(setHttpProgress(progress));
        });
        const takes = res.results.flatMap((task) => task.takesInst);
        const rel_takeFlagsInst = takes.flatMap((take) => take.rel_takeFlagsInst);
        const assetInst = res.results.flatMap((task) => task.assetInst);
        const rel_takeRefMediasInst = takes.flatMap((take) => take.rel_takeRefMediasInst);
        const rel_takeValidationMediasInst = takes.flatMap((take) => take.rel_takeValidationMediasInst);
        const validationMediasInst = takes.flatMap((take) => take.validationMediasInst);
        const refMediasInst = takes.flatMap((take) => take.refMediasInst);
        dispatch(setAllTakes(takes));
        dispatch(setAllRelTakesFlags(rel_takeFlagsInst));
        dispatch(setAssetsFromTasks(assetInst));
        dispatch(setAllMedias([...validationMediasInst, ...refMediasInst]));
        dispatch(setAllTakeValidationMedias(rel_takeValidationMediasInst));
        dispatch(setAllTakeRefMedias(rel_takeRefMediasInst));
        dispatch(setStateKey('tasks'));
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const fetchAllTasksStats = createAsyncThunk('reduxTasksStats/fetchAll', (queries_1, _a) => __awaiter(void 0, [queries_1, _a], void 0, function* (queries, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.tasks.fetchAll(Object.assign({ statMode: 'statsOnly' }, queries));
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const fetchUserTasks = createAsyncThunk('reduxTasks/fetchUser', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ userId, queries }, { fulfillWithValue, rejectWithValue, dispatch }) {
    try {
        const res = yield api.tasks.fetchAll(Object.assign({ assignedUser: userId }, queries), {}, (progress) => {
            dispatch(setHttpProgress(progress));
        });
        const takes = res.results.flatMap((task) => task.takesInst);
        const rel_takeFlagsInst = takes.flatMap((take) => take.rel_takeFlagsInst);
        const assetInst = res.results.flatMap((task) => task.assetInst);
        dispatch(setAllTakes(takes));
        dispatch(setAllRelTakesFlags(rel_takeFlagsInst));
        dispatch(setAssetsFromTasks(assetInst));
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const fetchMyTasks = createAsyncThunk('reduxTasks/fetchMyTasks', (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (params = {}, { fulfillWithValue, rejectWithValue, dispatch }) {
    try {
        const res = yield api.users.myTasks(null, Object.assign(Object.assign({}, params.queries), { statMode: 'datasOnly' }), {}, (progress) => {
            dispatch(setHttpProgress(progress));
        });
        const takes = res.results.flatMap((task) => task.takesInst);
        const rel_takeFlagsInst = takes.flatMap((take) => take.rel_takeFlagsInst);
        const assetInst = res.results.flatMap((task) => task.assetInst);
        const activities = res.results.flatMap((task) => task.activitiesInst);
        dispatch(setAllTakes(takes));
        dispatch(setAllRelTakesFlags(rel_takeFlagsInst));
        dispatch(setAssetsFromTasks(assetInst));
        dispatch(setAllActivities(activities));
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const fetchMyPastTasks = createAsyncThunk('reduxTasks/fetchMyPastTasks', (params_1, _a) => __awaiter(void 0, [params_1, _a], void 0, function* (params, { fulfillWithValue, rejectWithValue, dispatch }) {
    try {
        const res = yield api.users.myPastTasks(null, Object.assign(Object.assign({}, params.queries), { statMode: 'datasOnly' }), {}, (progress) => {
            dispatch(setHttpProgress(progress));
        });
        const takes = res.results.flatMap((task) => task.takesInst);
        const takesFlags = takes.flatMap((take) => take.rel_takeFlagsInst);
        const assetInst = res.results.flatMap((task) => task.assetInst);
        const activities = res.results.flatMap((task) => task.activitiesInst);
        dispatch(setAllTakes(takes));
        dispatch(setAllRelTakesFlags(takesFlags));
        dispatch(setAssetsFromTasks(assetInst));
        dispatch(setAllActivities(activities));
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const updateTask = createAsyncThunk('reduxTasks/update', (updatedTask_1, _a) => __awaiter(void 0, [updatedTask_1, _a], void 0, function* (updatedTask, { fulfillWithValue, rejectWithValue }) {
    try {
        yield verifyStartEndEarlyLatestDates(updatedTask);
        const res = yield api.tasks.collection.update(updatedTask);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
// actions for middleware
export const updateTaskAction = updateTask.fulfilled;
const { actions, reducer } = createSlice({
    name: 'reduxTasks',
    initialState,
    reducers: {
        setAllTasks: (state, { payload }) => {
            const tasks = [...state.allTasks, ...payload];
            const newData = removeDuplicates(tasks, (task) => task.id);
            state.allTasks = newData;
        },
        updateTasksStatus: (state, { payload }) => {
            let newData;
            if (Array.isArray(payload)) {
                newData = updateDataFromCollection(state.allTasks, payload);
            }
            else {
                newData = [...state.allTasks].map((task) => {
                    if (task.id === payload.id) {
                        return Object.assign(Object.assign({}, task), payload);
                    }
                    return task;
                });
            }
            state.allTasks = newData;
        },
        resetAllTasks: (state) => {
            state.allTasks = [];
        },
        resetTasks: (state) => {
            state.data = [];
        },
        setLoading: (state, { payload }) => {
            state.loading = payload;
        },
        updateTaskFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const newData = state.allTasks.map((task) => {
                if (task.id === updatedPayload.id) {
                    return Object.assign(Object.assign({}, task), updatedPayload);
                }
                return task;
            });
            state.allTasks = newData;
        },
        setHttpProgress: (state, { payload }) => {
            return Object.assign(Object.assign({}, state), { httpProgress: payload });
        },
    },
    extraReducers: (builder) => {
        // FETCH ALL TASKS
        builder.addCase(fetchAllTasks.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchAllTasks.fulfilled, (state, { payload }) => {
            const alltasks = [...state.allTasks, ...payload.results];
            const newAllTasks = removeDuplicates(alltasks, (task) => task.id);
            state.allTasks = newAllTasks;
            state.data = payload.results;
            state.count = payload.count;
            state.httpProgress = 0;
            state.loading = false;
        });
        builder.addCase(fetchAllTasks.rejected, (state, { payload }) => {
            state.loading = false;
        });
        // FETCH MY TASKS
        builder.addCase(fetchMyTasks.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchMyTasks.fulfilled, (state, { payload }) => {
            const alltasks = [...state.allTasks, ...payload.results];
            const newAllTasks = removeDuplicates(alltasks, (task) => task.id);
            state.allTasks = newAllTasks;
            state.data = payload.results;
            state.count = payload.count;
            state.loading = false;
        });
        builder.addCase(fetchMyTasks.rejected, (state, { payload }) => {
            state.loading = false;
        });
        // FETCH MY PAST TASKS
        builder.addCase(fetchMyPastTasks.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchMyPastTasks.fulfilled, (state, { payload }) => {
            const alltasks = [...state.allTasks, ...payload.results];
            const newAllTasks = removeDuplicates(alltasks, (task) => task.id);
            state.allTasks = newAllTasks;
            state.data = payload.results;
            state.count = payload.count;
            state.loading = false;
        });
        builder.addCase(fetchMyPastTasks.rejected, (state, { payload }) => {
            state.loading = false;
        });
        // FETCH ALL TASKS STATS
        builder.addCase(fetchAllTasksStats.pending, (state) => {
            state.statsIsLoading = true;
        });
        builder.addCase(fetchAllTasksStats.fulfilled, (state, { payload }) => {
            state.stats = payload.stats;
            state.statsIsLoading = false;
            state.loading = false;
        });
        builder.addCase(fetchAllTasksStats.rejected, (state, { payload }) => {
            state.statsIsLoading = false;
        });
        // FETCH USER TASKS
        builder.addCase(fetchUserTasks.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchUserTasks.fulfilled, (state, { payload }) => {
            const alltasks = [...state.allTasks, ...payload.results];
            const newAllTasks = removeDuplicates(alltasks, (task) => task.id);
            state.allTasks = newAllTasks;
            state.data = payload.results;
            state.count = payload.count;
            state.loading = false;
        });
        builder.addCase(fetchUserTasks.rejected, (state, { payload }) => {
            state.loading = false;
        });
        // UPDATE TASK
        builder.addCase(updateTask.pending, (state) => { });
        builder.addCase(updateTaskAction, (state, { payload }) => {
            const newAllTasksData = updateDataFromCollection(state.allTasks, payload);
            const newData = updateDataFromCollection(state.data, payload);
            state.data = newData;
            state.allTasks = newAllTasksData;
        });
        builder.addCase(updateTask.rejected, (state, { payload }) => {
            state.loading = false;
        });
    },
});
export const { setAllTasks, resetAllTasks, resetTasks, updateTaskFromWS, setLoading, setHttpProgress, updateTasksStatus, } = actions;
export default reducer;
